import React, { forwardRef, useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { InLoader } from "./ui";
import { useDropzone } from 'react-dropzone';
import { instance } from "./axios";
import { toast } from "react-toastify";
import { BsUpload } from 'react-icons/bs';
import { AiOutlineFile } from 'react-icons/ai';
import { MdOutlineVisibility, MdOutlineVisibilityOff, MdFileDownload, MdOutlineDelete } from 'react-icons/md';
import { Tooltip } from "antd";

import Swal from "sweetalert2";


export function Uploader(props) {
  const { onSave, uid, category, ...other } = props;
  const [error, setError] = useState([]);
  const [state, setState] = useState({});

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
  };



  const processUpload = (a) => new Promise((resolve, reject) => {
    var formData = new FormData();
    if (category == 'request') {
      formData.append("id", uid);
    } else if (category == 'client') {
      formData.append("cust_id", uid);
    }

      formData.append("file[]", a);

    setState({ ...state, loader: true })
    instance({
      method: "post",
      url: "/cust_upload_file",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        setState({ ...state, loader: false })

        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
          if (response.data.errors) {
            setError(prevState => [...prevState, ...response.data.errors])
          }
        }
        if (response.data.status == "success") {

          toast(response.data.msg, { type: "success" });
          //setState({ ...state, documents: [...state.documents, ...response.data.files] })
          onSave(response.data.files)

        }
        resolve()
      })
      .catch(function (response) { toast(response.message, { type: "error" }); setState({ ...state, loader: false }) });
  })




  var handleSave = (e) => {
    //setState({ ...state, loader: true });
    setError([]);
    if (e.length == 0)
      return;
      let promise = Promise.resolve()
      for (const a of e) {
        
  
          promise = promise.then(() => processUpload(a))
        
      }
  };

  const { getRootProps, fileRejections, getInputProps } = useDropzone({
    // Note how this callback is never invoked if drop occurs on the inner dropzone
    onDrop: files => handleSave(files),
    maxSize: 10485760,
    maxFiles: 10,
    accept: {
      'application/vnd.ms-excel': ['.xls', '.xlsx'],
      'application/pdf': ['.pdf'],
      'text/csv': ['.csv'],
      'text/json': ['.json'],
      'application/zip': ['.zip'],
      'text/txt': ['.txt'],
      'text/xml': ['.xml'],
      'application/msword': ['.doc', '.docx'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
    }
  });


  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <div className="alert alert-danger" role="alert" key={file.path}>
      <b>{file.path}</b><br></br>

      {errors.map(e => (
        <span key={e.code}>○ {e.code == 'file-invalid-type' && 'Invalid file type'}{e.code == 'file-too-large' && 'File is large (Max. 10MB)'} {e.code == 'too-many-files' && 'Too many files (Max. 10 files at once)'} </span>
      ))}

    </div>
  ));



  return (
    <div>
      <div className="position-relative">
        {state.loader && <InLoader />}
        <div {...getRootProps({ className: 'dropzone uploadbox' })} >
          <input {...getInputProps()} />
          <span className="fs-3 text-primary pointer">
            <BsUpload />
          </span>
          <p className="text-dark pe-none">Drop files here or click to upload.</p>
          <small className="text-muted">Maximum File Size: 10 MB (Max. 10 files at once)  |  File Format: CSV, XLS, XLSX, DOC, PDF, JPG, JSON, XML, ZIP</small>
        </div>
      </div>
      {fileRejectionItems && <div className="mt-3">{fileRejectionItems}</div>}
      {error && error.length > 0 && error.map((val, index) => (
        <div className="alert alert-danger" role="alert" key={index}>
          <b>{val.file}</b><br></br>

          {val.msg.map((val1, index1) => (
            <span key={index1}>○ {val1} </span>
          ))}

        </div>
      ))}
    </div>
  );
}


export function DocList(props) {
  const { setData, category, data, can_edit,  ...other } = props;
  const [state, setState] = useState({});
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {

        var arr = data.slice()
        arr.filter(x => x.id == id)[0].loading = true;
        setData(arr)
        instance
          .get("/cust_delete_file?id=" + id)
          .then(function (response) {
            if (response.data.status == 'success') {

              var arr = data;
              arr.filter(x => x.id == id)[0].loading = false;
              var arr1 = arr.filter(x => x.id !== id);
              setData(arr1)
              toast(response.data.msg, { type: "success" });

            } else {
              toast(response.data.msg, { type: "error" });
            }


          })

      }
    })


  }



  const downloadFile = (id, doc) => {
    var arr = data.slice()
    arr.filter(x => x.id == id)[0].loading = true;
    setData(arr)
    instance
      .get("cust_file_download?id=" + id + "&doc=" + doc)
      .then(function (response) {

        arr.filter(x => x.id == id)[0].loading = false;
        setData(arr)
        if (response.data.status == 'success') {

          const link = document.createElement('a');
          link.href = response.data.url;
          link.download = doc;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          toast(response.data.msg, { type: "error" });
        }


      })
  }

  return (
    <>
      {data && data.length > 0 && (
        <div className="" >

          {data.map((val, index) => (
            <div key={index} className={`list1 d-flex align-items-center ${val.loading && 'opacity-25'}`}>
              <div className="flex-grow-1"><AiOutlineFile /> <span className="text-break">{val.doc}</span></div>

              <div className="d-flex" style={{ height: '28px', width: '70px' }}>
              <Tooltip title="Download file">
                  <a className="btn btn-light btn-sm ms-2" onClick={() => downloadFile(val.id, val.doc)}><MdFileDownload /></a>
                </Tooltip>


                {can_edit == true && (
                   <Tooltip title="Delete file">
                    <a className="btn btn-light text-danger btn-sm ms-2" onClick={() => handleDelete(val.id)}><MdOutlineDelete /></a>
                  </Tooltip>

                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}